import Cookies from "universal-cookie";

const cookies = new Cookies();
const BASE = process.env.BACKOFFICE_SERVER_URL || "";

const clientError = (status, message) => ({ status, message });

// GET {BACKOFFICE_SERVER_URL}/activity/insights — painel de uso (admin-only).
export const fetchActivityInsights = async (filters = {}) => {
  if (!BASE) throw clientError(0, "Backoffice não configurado.");
  const query = new URLSearchParams();
  for (const [key, value] of Object.entries(filters)) {
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      query.set(key, String(value).trim());
    }
  }
  const { token } = cookies.get("userId") || {};
  let response;
  try {
    response = await fetch(`${BASE.replace(/\/+$/, "")}/activity/insights?${query.toString()}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch {
    throw clientError(0, "Não foi possível comunicar com o servidor.");
  }
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    throw clientError(response.status, data?.message || "Não foi possível carregar o uso da plataforma.");
  }
  return data;
};
